import { useState, useEffect } from "react";
import MKBox from "components/MKBox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import MKButton from "components/MKButton";
import PropTypes from "prop-types";
import { settingsService } from "services/settingsService";
import TurndownService from "turndown";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

function RequestEmailForm({ handleRequestEmail, rejectRequestEmail }) {
  const [loading, setLoading] = useState(false);
  const [forwardQuestionMessage, setForwardQuestionMessage] = useState("");

  useEffect(() => {
    const fetchForwardQuestionMessage = async () => {
      try {
        setLoading(true);
        const response = await settingsService.getSetting("forward-question-message");
        const turndown = new TurndownService();
        const markdown = turndown.turndown(response.setting);
        const textSegments = markdown.split("\n");
        const formattedText = textSegments.map((segment, index) => (
          <React.Fragment key={index}>
            {segment}
            {index < textSegments.length - 1 && <br />}
          </React.Fragment>
        ));
        setForwardQuestionMessage(formattedText);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchForwardQuestionMessage();
  }, []);

  return (
    <MKBox width="100%" bgColor="white" borderRadius="xl" shadow="lg" p={3} sx={{ marginTop: 3 }}>
      <MKBox
        maxWidth="95%"
        sx={{
          padding: 0,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Grid item xs={12}>
          {loading ? (
            <CircularProgress />
          ) : (
            <Typography variant="body2" color="dark" sx={{ fontWeight: "normal" }}>
              {forwardQuestionMessage}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} mt={2}>
          <MKButton
            variant="outlined"
            color="info"
            sx={{ width: "45%", marginRight: "5%" }}
            onClick={rejectRequestEmail}
          >
            Nee
          </MKButton>
          <MKButton
            variant="gradient"
            color="info"
            sx={{ width: "45%", marginLeft: "5%" }}
            onClick={handleRequestEmail}
          >
            Ja
          </MKButton>
        </Grid>
      </MKBox>
    </MKBox>
  );
}

export default RequestEmailForm;

RequestEmailForm.propTypes = {
  handleRequestEmail: PropTypes.func.isRequired,
  rejectRequestEmail: PropTypes.func.isRequired,
};
